import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="bg-navy px-3 py-4 sm:px-6" data-id="element-160" data-mp="3kqw54mwtl6h6">
      <div className="mx-auto max-w-2xl" data-id="element-161" data-mp="3fze3rxqvx3vo">
        <h2 className="text-center font-display text-[1.45rem] font-extrabold uppercase leading-none text-white sm:text-[2rem]" data-id="element-162" data-mp="3fy2zlwtj1u41">
          WHAT POOL &amp; SPA PROFESSIONALS <span className="text-aqua" data-id="element-163" data-mp="36zinjeih2ios">ARE SAYING</span>
        </h2>
        <p className="mt-1 text-center text-[0.66rem] italic leading-tight text-white/60 sm:text-[0.76rem]" data-id="element-164" data-mp="36wmp7p2pprzt">
          The following are illustrative testimonial placeholders. Replace them with verified customer
          reviews before publishing.
        </p>
        <div className="mt-2 space-y-1.5" data-id="element-165" data-mp="2s308fi793eke">
          {testimonials.map(t => <figure key={t.name} className="rounded-md border border-navy-line border-l-4 border-l-aqua bg-navy-soft px-2.5 py-2" data-id="element-166" data-mp="v9omle2pl5zt">
              <div className="flex gap-0.5 text-sun" role="img" aria-label="5 out of 5 stars" data-id="element-167" data-mp="qb511es11w7z">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-3.5 w-3.5 fill-current" aria-hidden="true" data-id="element-168" data-mp="m5b59r5dlyje" data-mpi={i} />)}
              </div>
              <p className="mt-1 font-display text-[0.92rem] font-extrabold leading-tight text-white sm:text-[1.05rem]" data-id="element-169" data-mp="79bmnmkn4g00">
                “{t.headline}”
              </p>
              <blockquote className="mt-0.5 text-[0.78rem] leading-[1.4] text-white/80 sm:text-[0.9rem]" data-id="element-170" data-mp="zw64ebq2p19s">“{t.quote}”</blockquote>
              <figcaption className="mt-1.5 text-[0.7rem] leading-tight sm:text-[0.8rem]" data-id="element-171" data-mp="14uzl0d0np8e6">
                <span className="font-bold text-aqua" data-id="element-172" data-mp="q5v2eupy925j">— {t.role}</span>
                <span className="text-white/65" data-id="element-173" data-mp="v57qfisk4f9p">
                  {' '}
                  · {t.name} · {t.location}
                </span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}